/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';

export const PriceIndicator = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
`;

export const RadioGroup = {
  display: 'flex',
  padding: '2% 0',
};

export const RadioElement = {
  fontSize: 16,
  paddingRight: '5%',
};

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 480px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const SpanTitle = styled.h3`
  text-align: center;
`;
